module.exports = __webpack_public_path__ + "svg/chevron-left.93866125f49565b32197dd76c75355a5.svg";